export function createNestedObjectFromDotKeys(
  pathMap: Record<string, any>,
): Record<string, any> {
  const result: Record<string, any> = {};

  for (const [path, value] of Object.entries(pathMap)) {
    const keys = path.split(".");
    let current = result;

    keys.forEach((rawKey, index) => {
      const isLast = index === keys.length - 1;

      // Check if this key is an array index, e.g., "[0]"
      const arrayMatch = rawKey.match(/^\[(\d+)\]$/);
      const isArrayIndex = arrayMatch !== null;
      const key = isArrayIndex ? parseInt(arrayMatch[1], 10) : rawKey;

      if (isLast) {
        if (isArrayIndex) {
          if (!Array.isArray(current)) current = [];
          current[key] = value;
        } else {
          current[key] = value;
        }
      } else {
        let nextKey = keys[index + 1];
        const isNextArray = /^\[\d+\]$/.test(nextKey);

        if (isArrayIndex) {
          if (!Array.isArray(current)) {
            current = [];
          }

          if (!current[key]) {
            current[key] = isNextArray ? [] : {};
          }
          current = current[key];
        } else {
          if (!current[key]) {
            current[key] = isNextArray ? [] : {};
          }
          current = current[key];
        }
      }
    });
  }

  return result;
}

export function getArrayChildren(
  keys: string[],
  basePath: string,
): string[] | undefined {
  // Normalize basePath: remove trailing dot if present
  const normalizedBase = basePath.replace(/\.$/, "");

  // Matches either: a.b[0]. or a.b.[0].  (with or without dot before [0])
  const pattern = new RegExp(`^${normalizedBase}(\\.|\\.)?\\[\\d+\\]\\.`);

  const result = keys.filter((key) => pattern.test(key));
  return result.length > 0 ? result : undefined;
}
